/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [{
  action: 'getSystemGameCategoriesByRootId',
  message: messages.SUCCESS_GET_SYSTEM_GAME_CATEGORIES_BY_ROOT_ID,
  method: 'GET',
  path: '/system/:systemId/game-categories/:rootId',
  payloadType: 'collection',
  permissionIdentity: permissionIdentities.GET_SYSTEM_GAME_CATEGORY,
  requestSchema: requestSchemas.systemGameCategories.getSystemGameCategoriesByRootId,
  scopes: [
    scopes.DEFAULT,
    scopes.SYSTEM_GAME_CATEGORIES_DEACTIVATED_BY_ROOT_ID,
    scopes.SYSTEM_GAME_CATEGORIES_INPUT_BY_ROOT_ID,
  ],
}];
